var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fancy-table',{attrs:{"layoutArray":_vm.trs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('fancy-table-item',{attrs:{"trItem":item,"index":index}},[_vm._v(" test111 ")])]}}])}),_vm._v(" "+_vm._s(_vm.trs)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }